import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const Landing = ({ isAuthenticated }) => {
  if (isAuthenticated) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <div id="landing">
      <h1>
        U<span>i School</span>
      </h1>
      <p>Welcome to the Network</p>
      {/* <div id="frame">
            <div id="landing-text">#Social</div>
          </div> */}
      <div className="buttons">
        <Link to="/register" className="register-btn shadow-sm">
          Sign Up
        </Link>
        <Link to="/login" className="login-btn shadow-sm">
          Login
        </Link>
      </div>
    </div>
  );
};

Landing.propTypes = {
  isAuthenticated: PropTypes.bool
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps)(Landing);
